<template>
  <div class="principal-management">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('titleManagePrincipals','titleManagePrincipals') }}</h6>
          <div class="element-box">
            <div>
              <div class="element-info">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-8">
                    <div class="element-info-with-icon">
                      <div class="element-info-icon">
                        <fontAwesomeIcon  :icon="['fas', 'key']" class="" size="1x"/>
                      </div>
                      <div class="element-info-text">
                        <h5 class="element-inner-header">{{ t('titleManagePrincipals','titleManagePrincipals') }}</h5>
                        <div class="element-inner-desc">{{ t('descManagePrincipals','descManagePrincipals') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <form v-on:submit.prevent="addPrincipal">
                <div class="col-lg-12 row">
                  <div class="col-lg-2">
                    <div class="form-group">
                      <label for="add-principal" class="d-block text-center"><span class="text-danger">* </span>{{t('labelAddPrincipal','labelAddPrincipal') }}</label>
                      <input id="add-principal" v-model="principalData.principal" class="form-control text-center" :placeholder="t('labelAddPrincipal','labelAddPrincipal')" type="text">
                    </div>
                  </div>
                  <div v-if="principals.displayKeySub100" class="col-lg-2">
                    <div class="form-group">
                      <label for="key-sub" class="">{{t('labelKeySub100','labelKeySub100')}}</label>
                      <b-form-radio-group id="key-sub" v-model="principalData.keySub">
                        <b-form-radio name="key-sub" :value="true">{{t('optionYes', 'optionYes')}}</b-form-radio>
                        <b-form-radio name="key-sub" :value="false">{{t('optionNo', 'optionNo')}}</b-form-radio>
                      </b-form-radio-group>
                    </div>
                  </div>
                </div>
                <h6 class="element-header">{{t('titlePrincipalsReportDeliveryRules','titlePrincipalsReportDeliveryRules')}}</h6>
                <div class="col-lg-12 row">
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label for="add-principal" class="d-block text-center"><span class="text-danger">* </span>{{t('labelEmailAddressForProofReports','labelEmailAddressForProofReports') }}</label>
                      <input id="add-principal" v-model="principalData.emailAddressForProofReports" class="form-control text-center" :placeholder="t('labelEmailAddressForProofReports','labelEmailAddressForProofReports')" type="text">
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label for="add-principal" class="d-block text-center"><span class="text-danger">* </span>{{t('labelEmailAddressforProofReminderReports','labelEmailAddressforProofReminderReports') }}</label>
                      <input id="add-principal" v-model="principalData.emailAddressforProofReminderReports" class="form-control text-center" :placeholder="t('labelEmailAddressforProofReminderReports','labelEmailAddressforProofReminderReports')" type="text">
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label for="add-principal" class="d-block text-center"><span class="text-danger">* </span>{{t('labelEmailAddressforStartReports','labelEmailAddressforStartReports') }}</label>
                      <input id="add-principal" v-model="principalData.emailAddressforStartReports" class="form-control text-center" :placeholder="t('labelEmailAddressforStartReports','labelEmailAddressforStartReports')" type="text">
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label for="add-principal" class="d-block text-center"><span class="text-danger">* </span>{{t('labelEmailAddressforFinalReports','labelEmailAddressforFinalReports') }}</label>
                      <input id="add-principal" v-model="principalData.emailAddressforFinalReports" class="form-control text-center" :placeholder="t('labelEmailAddressforFinalReports','labelEmailAddressforFinalReports')" type="text">
                    </div>
                  </div>
                </div>
                <ResponseInfo class="mb-3" v-if="getResponseInfo.responseName == 'principalManagement'" />
                <transition name="fade">
                  <div class="col-12 mb-3" v-if="(getResponseInfo.responseName == 'principalManagement') && (getResponseInfo.key == 'emailNotValid')">
                    <b-alert class="alert alert-dismissible alert-danger" variant="form-error-box" show fade>
                      <div class="error-msg">
                        <span >{{t('errorInEmailfield', 'errorInEmailfield')}}:
                          <span v-if="getResponseInfo.field == 'proof'">{{t('labelEmailAddressForProofReports','labelEmailAddressForProofReports')}}</span>
                          <span v-if="getResponseInfo.field == 'proof_reminder'">{{t('labelEmailAddressforProofReminderReports','labelEmailAddressforProofReminderReports')}}</span>
                          <span v-if="getResponseInfo.field == 'start'">{{t('labelEmailAddressforStartReports','labelEmailAddressforStartReports')}}</span>
                          <span v-if="getResponseInfo.field == 'final'">{{t('labelEmailAddressforFinalReports','labelEmailAddressforFinalReports')}}</span>
                        </span>
                        <span class="ml-5">
                          {{t('invalidEmailAddress', 'invalidEmailAddress')}}: {{getResponseInfo.email}}
                        </span>
                      </div>
                    </b-alert>
                  </div>
                </transition>
                <div class="col-lg-12 row">
                  <div class="col-12">
                    <button v-if="!isLoading" :disabled="!filledOutForm" class="btn btn-primary float-right" type="submit" >{{ t('buttonAddPrincipalText','buttonAddPrincipalText') }}</button>
                    <b-button v-if="isLoading" class="float-right" variant="primary" disabled>
                      <b-spinner small type="grow"></b-spinner>
                       {{ t('buttonAddPrincipalText','buttonAddPrincipalText') }}
                    </b-button>
                  </div>
                </div>
              </form>

            </div>
          </div>
          <div class="element-box">
            <h6 class="element-header">{{t('titleDeleteAndAssignPrincipals','titleDeleteAndAssignPrincipals')}}</h6>
            <div class="col-12 row justify-content-end mb-5">
              <label for="assigned-users-level" class="col-1 align-self-center">{{t('labelUsersLevel','labelUsersLevel') }}</label>
              <b-form-select class="col-2" id="assigned-users-level" @change="changeUserLevel" v-model="chosenUserLevel">
                <option :value="'all'" >{{ t('optionAllUserLevels','optionAllUserLevels') }}</option>
                <option :value="'Newsnet'" >{{ t('optionUserLevelNewsnet','optionUserLevelNewsnet') }}</option>
                <option :value="'Superadmin'" >{{ t('optionUserLevelSuperadmin','optionUserLevelSuperadmin') }}</option>
                <option :value="'Admin'" >{{ t('optionUserLevelAdmin','optionUserLevelAdmin') }}</option>
                <option :value="'CreditController'" >{{ t('optionUserLevelCreditController','optionUserLevelCreditController') }}</option>
                <option :value="'Caller'" >{{ t('optionUserLevelCaller','optionUserLevelCaller') }}</option>
                <option :value="'CM'" >{{ t('optionUserLevelCM','optionUserLevelCM') }}</option>
                <option :value="'Staff'" >{{ t('optionUserLevelStaff','optionUserLevelStaff') }}</option>
                <option :value="'Customer'" >{{ t('optionUserLevelCustomer','optionUserLevelCustomer') }}</option>
              </b-form-select>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="table-records-info" v-if="principals.total">
                <p class="mb-0">
                  <template v-if="principals.total == 1">
                  {{principals.total}} {{ t('principalFoundLabel','principalFoundLabel') }}
                  </template>
                  <template v-else>
                  {{principals.total}} {{ t('principalsFoundLabel','principalsFoundLabel') }}
                  </template>
                </p>
              </div>
              <div class="d-flex">
                <b-pagination v-if="principals.total" ref="paginationTop" class="m-0" @input="changeURL" v-model="searchPrincipals.page" :total-rows="principals.total" :per-page="searchPrincipals.perPage" aria-controls="batches-table">
                </b-pagination>
                <b-input-group class="ml-5">
                  <b-input-group-prepend>
                    <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="searchPrincipals.perPage" @change="changeURL" :options="pageOptions"></b-form-select>
                </b-input-group>
              </div>
            </div>
            <b-table id="principles-table" striped hover responsive :fields="fields" :items="principals.principals" :busy.sync="isBusy" :thead-class="'brand-color'">
              <template v-slot:head(name)="data">
                <span> {{ t('principalName', 'principalName') }}</span>
              </template>
              <template v-slot:head(assign_users)="data">
                <span> {{ t('nonAssignedUsers', 'nonAssignedUsers') }} <span v-if="principals.nonAssignedUsersTotal" class="th-bigtext">( {{principals.nonAssignedUsersTotal}} )</span></span>
              </template>
              <template v-slot:head(users_with_pan_principle_access_only)="data">
                <span> {{ t('nonAssignedPanPrincipleUsers', 'nonAssignedPanPrincipleUsers') }} <span v-if="principals.nonAssignedPanPrincipleUsersTotal" class="th-bigtext">( {{principals.nonAssignedPanPrincipleUsersTotal}} )</span></span>
              </template>
              <template v-slot:head(assigned_users)="data">
                <span> {{ t('assignedUsers', 'assignedUsers') }}</span>
              </template>
              <template v-slot:head(id)="data">
                <span> {{ t('deletePrincipal', 'deletePrincipal') }}</span>
              </template>
              <template class="busy-row" v-slot:table-busy>
                <vcl-table v-if="isBusy" :rows="principalData.perPage" :columns="5"></vcl-table>
              </template>
              <template v-slot:empty="scope">
                <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
              </template>
              <template v-slot:cell(name)="data">
                {{data.item.name}}
              </template>
              <template v-slot:cell(assign_users)="data">
                <fontAwesomeIcon v-if="principals.nonAssignedUsersTotal < 1"  :icon="['fas', 'user-plus']" class="text-muted " />
                <fontAwesomeIcon v-else :icon="['fas', 'user-plus']" class="text-primary showhand " size="1x" @click="modalCreator({id: 'modalNonAssignedUsers', title: t('assignUsersModalHead','assignUsersModalHead'), open: 'open'}, data.item, $event.target)"/>
              </template>
              <template v-slot:cell(users_with_pan_principle_access_only)="data">
                <fontAwesomeIcon v-if="principals.nonAssignedPanPrincipleUsersTotal < 1"  :icon="['fas', 'user']" class="text-muted " />
                <fontAwesomeIcon v-else  :icon="['fas', 'user']" class="text-primary showhand " size="1x" @click="modalCreator({id: 'nonAssignedpanPrincipleUsersModal', title: t('nonAssignedpanPrincipleUsersModalHead','nonAssignedpanPrincipleUsersModalHead'), open: 'open'}, data.item, $event.target)"/>
              </template>
              <template v-slot:cell(assigned_users)="data">
                <fontAwesomeIcon v-if="data.item.assigned_users < 1"  :icon="['fas', 'users']" class="text-muted " />
                <fontAwesomeIcon v-else  :icon="['fas', 'users']" class="text-primary showhand " size="1x" @click="modalCreator({id: 'assignedUsersModal', title: t('assignedUsersModalHead','assignedUsersModalHead'), open: 'open'}, data.item, $event.target)"/>
                <span v-if="data.item.assigned_users"> ( {{data.item.assigned_users}} )</span>
              </template>
              <template v-slot:cell(id)="data">
                <fontAwesomeIcon  :icon="['fas', 'trash']" class="text-danger showhand " size="1x" @click="modalCreator({id: 'deletePrincipleModal', title: t('deletePrincipalModalHead','deletePrincipalModalHead'), open: 'open'}, data.item, $event.target)"/>
              </template>
            </b-table>
            <div class="d-flex justify-content-between align-items-center">
              <div class="table-records-info" v-if="principals.total">
                <p class="mb-0">
                  <template v-if="principals.total == 1">
                  {{principals.total}} {{ t('principalFoundLabel','principalFoundLabel') }}
                  </template>
                  <template v-else>
                  {{principals.total}} {{ t('principalsFoundLabel','principalsFoundLabel') }}
                  </template>
                </p>
              </div>
              <div class="d-flex">
                <b-pagination v-if="principals.total" ref="paginationBottom" class="m-0" v-model="searchPrincipals.page" @input="changeURL" :total-rows="principals.total" :per-page="searchPrincipals.perPage" aria-controls="batches-table">
                </b-pagination>
                <b-input-group class="ml-5">
                  <b-input-group-prepend>
                    <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="searchPrincipals.perPage" @change="changeURL" :options="pageOptions"></b-form-select>
                </b-input-group>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalDeletePrincipal/>
      <ModalAssignedUsers/>
      <ModalNonAssignedUsers/>
      <ModalNonAssignedPanPrincipleUsers/>
      <div v-if="modal['modalData'].open" class="modal-backdrop show"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import { VclTable } from 'vue-content-loading'
import Loading from 'vue-loading-overlay'
import ModalDeletePrincipal from '@/components/Principal_Management/ModalDeletePrincipal.vue'
import ModalAssignedUsers from '@/components/Principal_Management/ModalAssignedUsers.vue'
import ModalNonAssignedUsers from '@/components/Principal_Management/ModalNonAssignedUsers.vue'
import ModalNonAssignedPanPrincipleUsers from '@/components/Principal_Management/ModalNonAssignedPanPrincipleUsers.vue'

export default{
  name: 'principal_management',
  provide() {
    return {
      modal: this.modal,
      resetModal: this.resetModal,
      isLoading: this.isLoading,
      userLevelName: this.userLevelName,
      searchPrincipals: this.searchPrincipals,
      deletePrincipal: this.deletePrincipal,
      refreshResults: this.refreshResults
    }
  },
  data() {
    return {
      isLoading: false,
      isBusy: false,
      //add principle form
      principalData: {},
      //principle deletion
      principalToDelete: 0,
      //principle list table and related functions
      pageOptions: [10, 20, 50, 100],
      fields: [
        { key: "id", label: "", tdClass: ['column-small', 'text-left'] },
        { key: "name", label: "", tdClass: 'column-big' },
        { key: "assigned_users", label: "", tdClass: 'column-small', thClass: 'text-center' },
        { key: "users_with_pan_principle_access_only", label: "", tdClass: 'column-small', thClass: 'text-center' },
        { key: "assign_users", label: "", tdClass: 'column-small', thClass: 'text-center' }
      ],
      chosenUserLevel: 'all',
      searchPrincipals: {
        page: 1,
        perPage: 20
      },
      modal: {
        modalData: {},
        principleData: {},
        updateData: {}
      }
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    principals() {
        return this.$store.getters['principalStore/getPrincipals']
    },
    filledOutForm() {
      if( (this.principalData.principal != undefined)
      && (this.principalData.emailAddressForProofReports != undefined)
      && (this.principalData.emailAddressforProofReminderReports != undefined)
      && (this.principalData.emailAddressforStartReports != undefined)
      && (this.principalData.emailAddressforFinalReports != undefined)
      ) {
        return true
      } else {
        return false
      }
    },
    principalUserLevel:{
      get() {
        return this.$store.getters['principalStore/getPrincipalUserLevel']
      },
      set(newLevel) {
        this.$store.commit('principalStore/setPrincipalUserLevel', newLevel)
      }
    }
  },
  methods:{
    clearErrors() {
      this.$store.dispatch('alertClearErrors')
    },
    changeURL() {
      let change = false
      if(this.searchPrincipals.page != this.$route.query.page) {
        change = true
      }
      if(this.searchPrincipals.perPage != this.$route.query.per_page) {
        change = true
      }
      if(this.principalUserLevel != this.$route.query.user_level) {
        change = true
      }
      if(change) {
        this.$router.push({ query: { ...this.$route.query, page: this.searchPrincipals.page, per_page: this.searchPrincipals.perPage, user_level: this.principalUserLevel} })
      }
      this.refreshResults(true)
    },
    changeUserLevel() {
      let newLevel = this.chosenUserLevel
      this.principalUserLevel = newLevel
      this.$router.push({ query: { ...this.$route.query, page: this.searchPrincipals.page, per_page: this.searchPrincipals.perPage, user_level: this.principalUserLevel} })
      this.refreshResults(true)
    },
    userLevelName(level) {
      let name = ''
      switch (level) {
        case '0.00':
          name = 'customer'
          break;
        case '0.50':
          name = 'staff'
          break;
        case '1.00':
          name = 'creditController'
          break;
        case '1.50':
          name = 'caller'
          break;
        case '2.00':
          name = 'admin'
          break;
        case '2.50':
          name = 'superAdmin'
          break;
        case '3.00':
          name = 'newsnet'
          break;
        default:
          name = 'undefined'
      }

      return name
    },
    refreshResults(clearResponse) {
      this.isBusy = true
      this.$store.dispatch('principalStore/getPrincipals',  { ...this.searchPrincipals,  principleUsersLevel: this.principalUserLevel}).then(
        () => {
          this.isBusy = false
        }
      )
      if(clearResponse) {
        this.$store.dispatch('alertClearResponse')
      }
    },
    addPrincipal() {
      this.isBusy = true
      this.$store.dispatch('principalStore/addPrincipal', this.principalData).then(
        () => {
          this.refreshResults(false)
          this.isBusy = false
        }
      )
    },
    deletePrincipal(principalToDelete) {
      this.$store.dispatch('principalStore/deletePrincipal', principalToDelete).then(
        () => {
          let response = this.getResponseInfo
          if(response.status == 'success') {
            this.$root.$emit('bv::hide::modal', 'deletePrincipleModal')
            this.refreshResults(true)
          } else {
            this.refreshResults(false)
          }
        }
      )
    },
    //MODALS
    modalCreator(modalData, principleData, button) {
      this.modal.modalData = modalData
      this.modal.principleData = { ...principleData }

      this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)
    },
    resetModal() {
      Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
      Object.keys(this.modal['principleData']).forEach((key) => (this.modal['principleData'][key] = '' ))
    }
  },
  created() {
    let change = false
    //setting up the default choice for key sub
    this.principalData.keySub = false

    if(Object.keys(this.$route.query).length) {
      //Pagination setup
      if(this.$route.query.page) {
        if(this.$route.query.page != this.searchPrincipals.page) {
          change = true
          this.searchPrincipals.page = parseInt(this.$route.query.page)
        }
      } else {
        change = true
        this.searchPrincipals.page = 1
      }

      if(this.$route.query.per_page) {
        if(this.$route.query.per_page != this.searchPrincipals.perPage) {
          this.searchPrincipals.perPage = parseInt(this.$route.query.per_page)
        }
      } else {
        change = true
        this.searchPrincipals.perPage = 20
      }

      if(this.$route.query.user_level) {
        if(this.$route.query.user_level != this.chosenUserLevel) {
          change = true
          this.chosenUserLevel = this.$route.query.user_level
        }
      } else {
        change = true
        this.chosenUserLevel = 'all'
      }
    } else {
      this.searchPrincipals.page = 1
      this.searchPrincipals.perPage = 20
      this.chosenUserLevel = 'all'
      change = true
    }

    if( !this.pageOptions.includes(this.searchPrincipals.perPage) ) {
        this.pageOptions.push(Number(this.searchPrincipals.perPage))
    }

    if(this.chosenUserLevel != this.principalUserLevel) {
      this.principalUserLevel = this.chosenUserLevel
      change = true
    }

    if(change) {
      this.$router.push({ query: { ...this.$route.query, page: this.searchPrincipals.page, per_page: this.searchPrincipals.perPage, user_level: this.principalUserLevel} })
    }

    //fetching principal setup
    this.$store.dispatch('principalStore/getPrincipals', { ...this.searchPrincipals, principleUsersLevel: this.principalUserLevel})
  },
  components: {
    Loading,
    ResponseInfo,
    VclTable,
    ModalDeletePrincipal,
    ModalAssignedUsers,
    ModalNonAssignedUsers,
    ModalNonAssignedPanPrincipleUsers
  }
}
</script>

<style scoped>
.showhand {
  cursor: pointer;
}
/*TABLE*/
.table-responsive  >>> #principles-table {
  margin: 2em 0em 2em 0em;
}
.table-responsive  >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}
.table-responsive  >>> .column-small {
  width: 10%;
  text-align: center;
}
.table-responsive  >>> .column-big {
  width: 60%;
}
.th-bigtext {
  font-weight: bold;
}

</style>
